import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

export const useAppReset = () => {
  const queryClient = useQueryClient();

  const resetAll = useCallback(async () => {
    queryClient.clear();
  }, [queryClient]);

  return {
    resetAll,
  };
};

export default useAppReset;
